var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07143 7H15.9286M9.07143 11H15.9286M9.07143 15H13.6429M4.5 5C4.5 4.46957 4.74082 3.96086 5.16947 3.58579C5.59812 3.21071 6.17951 3 6.78571 3H18.2143C18.8205 3 19.4019 3.21071 19.8305 3.58579C20.2592 3.96086 20.5 4.46957 20.5 5V19C20.5 19.5304 20.2592 20.0391 19.8305 20.4142C19.4019 20.7893 18.8205 21 18.2143 21H6.78571C6.17951 21 5.59812 20.7893 5.16947 20.4142C4.74082 20.0391 4.5 19.5304 4.5 19V5Z",
    stroke: "#6E6D92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.c1a6736cbd43c800241960a5f0999267.svg";
export { ForwardRef as ReactComponent };